import { BusinessCriticality } from '../api/common';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const BusinessCriticalitiesSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.BusinessCriticality.toString()}-${BusinessCriticality.high}`,
    value: BusinessCriticality.high,
    displayName: BusinessCriticality.high,
    categoryName: FilterTypesEnum.BusinessCriticality.toString(),
    filterType: FilterTypesEnum.BusinessCriticality,
  },
  {
    id: `${FilterTypesEnum.BusinessCriticality.toString()}-${BusinessCriticality.medium}`,
    value: BusinessCriticality.medium,
    displayName: BusinessCriticality.medium,
    categoryName: FilterTypesEnum.BusinessCriticality.toString(),
    filterType: FilterTypesEnum.BusinessCriticality,
  },
  {
    id: `${FilterTypesEnum.BusinessCriticality.toString()}-${BusinessCriticality.low}`,
    value: BusinessCriticality.low,
    displayName: BusinessCriticality.low,
    categoryName: FilterTypesEnum.BusinessCriticality.toString(),
    filterType: FilterTypesEnum.BusinessCriticality,
  },
];
